/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import deleteInvestmentProjectActions, {
    deleteInvestmentProjectTypes,
} from '../../../redux/investmentProjects/deleteInvestmentProject'
import { Delete } from '../../../serveur/axios'
import getAllInvestement from '../../../redux/investmentProjects/getAllInvestmentProject'

function* deleteInvestmentProjectSagas({ response }) {
    try {
        const res = yield Delete(`project_investment/${response.id}`)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    deleteInvestmentProjectActions.deleteInvestmentProjectSuccess(
                        res.data
                    )
                ),
                yield put(
                    getAllInvestement.getAllInvestmentProjectRequest({
                        type: response.dataType,
                    })
                ),
            ])
        } else {
            yield put(
                deleteInvestmentProjectActions.deleteInvestmentProjectFailure(
                    res
                )
            )
        }
    } catch (error) {
        yield put(
            deleteInvestmentProjectActions.deleteInvestmentProjectFailure(error)
        )
    }
}

export function* deleteInvestmentProjectSaga() {
    yield takeLatest(
        deleteInvestmentProjectTypes.DELETE_INVESTMENT_PROJECT_REQUEST,
        deleteInvestmentProjectSagas
    )
}
